// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"9b97a0ba","455":"eccf6be1"}[chunkId] + ".chunk.js";
};